<div class="sura-loader__container">
  <div class="sura-loader__spinner" role="status" aria-label="Cargando">
    <div class="sura-loader__ring"></div>
    <div class="sura-loader__ring"></div>
    <div class="sura-loader__ring"></div>
  </div>
  <p class="sura-loader__text">{{ text() }}</p>
</div>
